module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs product-list"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.tableClick($event)
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "产品图片",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "data-type": "img",
            "data-url": scope.row.thumbnail,
            "src": scope.row.thumbnail,
            "height": "30",
            "width": "30"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": "产品名称",
      "width": "180",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "productNo",
      "label": "编号",
      "width": "180",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品规格",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.specification || '--') + "\n          ")]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page.count > _vm.page.size),
      expression: "page.count > page.size"
    }],
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.page.page,
      "page-size": _vm.page.size,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.page.count
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cd9a74c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/supplier/product-list.vue
// module id = 1320
// module chunks = 82